'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});
var actionTypes = {
    FETCH_OBJECTIVES_REQUEST: 'FETCH_OBJECTIVES_REQUEST',
    FETCH_OBJECTIVES_SUCCEEDED: 'FETCH_OBJECTIVES_SUCCEEDED',
    FETCH_OBJECTIVES_FAILED: 'FETCH_OBJECTIVES_FAILED'
};

function fetchObjectivesRequest() {
    return {
        type: actionTypes.FETCH_OBJECTIVES_REQUEST
    };
}

function fetchObjectivesSucceeded(objectives) {
    return {
        type: actionTypes.FETCH_OBJECTIVES_SUCCEEDED,
        objectives: objectives
    };
}

function fetchObjectivesFailed() {
    return {
        type: actionTypes.FETCH_OBJECTIVES_FAILED
    };
}

var actionCreators = {
    fetchObjectivesRequest: fetchObjectivesRequest,
    fetchObjectivesSucceeded: fetchObjectivesSucceeded,
    fetchObjectivesFailed: fetchObjectivesFailed
};

exports.actionTypes = actionTypes;
exports.actionCreators = actionCreators;
//# sourceMappingURL=data:application/json;charset=utf-8;base64,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


//////////////////
// WEBPACK FOOTER
// ./src/client/actions/objectives.js
// module id = 47
// module chunks = 0